exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.validation-error{margin:0 auto 10px;padding:0\n}\n.validation-error__ul{list-style-image:none;margin:0\n}\n.confirmation__create-account--passwords{display:grid;gap:1rem\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d9a3e89","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/valuation-tool/components/Sections/CreateAccount.vue
// module id = PTOV
// module chunks = 1 2 4 5 15 17 18 19